import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditProductTag from "./AddEditProductTag";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";

class ProductGroupList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      fullList: [],

      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      filter: {
        name: "",
        description: "",
        status: "active"
      },

      showAddProductGroup: false,
      showFilter: false,
      showDelete: false,

      selectedRow: null,

      isFilterActive: false,

      listPageSettings: {

        Title: "Product Group",

        Search: {

          showSearch: true,

          placeholder: "Search by product group name",

          onSearch: (text) =>
            this.onSearch(text),

          onRefresh: () =>
            this.onRefreshClick(),

          onFilterClick: () =>
            this.setState({
              showFilter: true
            }),

          isFilterActive: false

        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "popup"
          }

        ],

        Columns: [

          {
            Name: "Name",
            Type: "field",
            Columns: [
              { Column: "Name" }
            ]
          },

          {
            Name: "Description",
            Type: "field",
            Columns: [
              { Column: "Description" }
            ]
          },

          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "Name", CSS: "bold" },
              { Column: "Description" }
            ]
          }

        ],

        RowButtons: [

          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit",
            Action: "popup"
          },

          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete",
            Action: "delete"
          }

        ]

      }

    };

  }

  componentDidMount() {

    this.fetchData();

  }

  fetchData = async () => {

    this.setState({
      loading: true
    });

    try {

      const res =
        await this.props.getProductTags();

      let data = [];

      if (
        res &&
        res.hasOwnProperty("productTags")
      ) {

        data = res.productTags;

      }

      this.setState({

        fullList: data,
        loading: false

      },
        this.applyFilterAndPaging
      );

    }

    catch (error) {

      console.log(error);

      this.setState({
        loading: false
      });

    }

  };

  applyFilter = (data) => {

    const { name, description, status } =
      this.state.filter;

    let result = [];

    for (let i = 0; i < data.length; i++) {

      let item = data[i];

      let matchName = true;
      let matchDescription = true;
      let matchStatus = true;

      // NAME FILTER
      if (name) {

        if (
          item.hasOwnProperty("Name") === false ||
          item.Name.toLowerCase()
            .indexOf(name.toLowerCase()) === -1
        ) {

          matchName = false;

        }

      }

      // DESCRIPTION FILTER
      if (description) {

        if (
          item.hasOwnProperty("Description") === false ||
          item.Description.toLowerCase()
            .indexOf(description.toLowerCase()) === -1
        ) {

          matchDescription = false;

        }

      }

      // STATUS FILTER
      if (status === "active") {

        if (
          item.hasOwnProperty("IsDeleted") === false ||
          item.IsDeleted === true
        ) {

          matchStatus = false;

        }

      }

      else if (status === "inActive") {

        if (
          item.hasOwnProperty("IsDeleted") === false ||
          item.IsDeleted === false
        ) {

          matchStatus = false;

        }

      }

      else if (status === "all") {

        matchStatus = true;

      }

      if (
        matchName === true &&
        matchDescription === true &&
        matchStatus === true
      ) {

        result.push(item);

      }

    }

    return result;

  };

  applyFilterAndPaging = () => {

    let filteredData =
      this.applyFilter(
        this.state.fullList
      );

    let from =
      (this.state.page - 1)
      * this.state.pageSize;

    let to =
      from + this.state.pageSize;

    let pageData =
      filteredData.slice(from, to);

    this.setState({

      list: pageData,

      totalCount:
        filteredData.length

    });

  };

  onSearch = (text) => {

    this.setState({

      filter: {

        ...this.state.filter,

        name: text

      },

      page: 1

    },

      this.applyFilterAndPaging

    );

  };

  // REFRESH = clear filter + load fresh data
  onRefreshClick = () => {

    this.setState({

      filter: {

        name: "",
        description: "",
        status: "active"

      },

      page: 1,

      isFilterActive: false

    },
      this.fetchData
    );

  };

  onApplyFilter = () => {

    this.setState({

      page: 1,

      showFilter: false,

      isFilterActive: true

    },

      this.applyFilterAndPaging

    );

  };

  onClearFilter = () => {

    this.setState({

      filter: {

        name: "",
        description: "",
        status: "active"

      },

      page: 1,

      showFilter: false,

      isFilterActive: false

    },

      this.applyFilterAndPaging

    );

  };

  onHeaderButtonClicked = (btn) => {

    if (
      btn.Action === "popup"
    ) {

      this.setState({

        showAddProductGroup: true,

        selectedRow: null

      });

    }

  };

  onRowButtonClicked = (btn, row) => {

    if (
      btn.Action === "popup"
    ) {

      this.setState({

        showAddProductGroup: true,

        selectedRow: row

      });

    }

    if (
      btn.Action === "delete"
    ) {

      this.setState({

        showDelete: true,

        selectedRow: row

      });

    }

  };

  // DELETE → IsDeleted = true handled in API
  deleteRecord = () => {

    const { selectedRow } = this.state;

    if (!selectedRow) {

      return;

    }

    if (
      selectedRow.hasOwnProperty("key") === false
    ) {

      alert("Invalid record");

      return;

    }

       this.setState(
          {

            showDelete: false,
            loading:true,

          },
        );

    this.props
      .deleteProductTag(
        selectedRow.key
      )
      .then((res) => {

        this.setState(
          {

            showDelete: false,

            selectedRow: null,
            loading:false

          },

          this.fetchData
        );

        console.log(res.message);

      })
      .catch((err) => {

        console.log(err);

        alert(err.message);

      });

  };

  onNextClick = () => {

    let totalPages =
      Math.ceil(

        this.state.totalCount

        / this.state.pageSize

      );

    if (

      this.state.page < totalPages

    ) {

      this.setState({

        page:

          this.state.page + 1

      },

        this.applyFilterAndPaging

      );

    }

  };

  onPreviousClick = () => {

    if (

      this.state.page > 1

    ) {

      this.setState({

        page:

          this.state.page - 1

      },

        this.applyFilterAndPaging

      );

    }

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({

      pageSize:

        Number(size),

      page: 1

    },

      this.applyFilterAndPaging

    );

  };

  onPostPopupSave = () => {

    this.setState({

      showAddProductGroup: false,

      selectedRow: null

    },

      this.fetchData

    );

  };

  onClosePopup = () => {

    this.setState({

      showAddProductGroup: false,

      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage 
           {...this.props} 
            onPageChange={this.onPageChange}

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state
                .listPageSettings
                .Search,

              isFilterActive:
                this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={
            (
              this.state.page - 1
            )
            *
            this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={
            this.onNextClick
          }

          onPreviousClick={
            this.onPreviousClick
          }

          onRecordsPerPageCountChange={
            this
              .onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />

        {this.state.showAddProductGroup && (

          <AddEditProductTag

            {...this.props}

            productGroup={
              this.state.selectedRow
            }

            onSave={() =>
              this.onPostPopupSave()
            }

            onClose={() =>
              this.onClosePopup()
            }

          />

        )}

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide={true}

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(type) => {

              if (
                type.toLowerCase()
                === "apply"
              ) {

                this.onApplyFilter();

              }

              if (
                type.toLowerCase()
                === "clear"
              ) {

                this.onClearFilter();

              }

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }

            ]}

          >

            <Input
              label="Name"
              type="text"
              value={
                this.state.filter.name
              }
              onChange={(val) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    name: val
                  }
                })
              }
            />

            <Input
              label="Description"
              type="text"
              value={
                this.state.filter.description
              }
              onChange={(val) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    description: val
                  }
                })
              }
            />

            <Input
              label="Status"
              type="select"
              value={
                this.state.filter.status
              }
              onChange={(val) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    status: val
                  }
                })
              }
            >

              <option value="active">
                Active
              </option>

              <option value="inActive">
                In Active
              </option>

              <option value="all">
                All
              </option>

            </Input>

          </Window>

        )}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal={true}

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(type) => {

              if (
                type.toLowerCase()
                === "yes"
              ) {

                this.deleteRecord();

              }

              else {

                this.setState({

                  showDelete: false,

                  selectedRow: null

                });

              }

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

      </>

    );

  }

}

export default ProductGroupList;